export const onLang = () => {
  let cn = require("@/locale/lang/zh_CN.json"),
    my_lan = require("./lang.js");
  let str = setTreat(cn);
  console.log("未翻译", str);
  let lang_obj = onTreat(cn, my_lan.split("\n")).lan_obj;
  console.log("翻译过后", lang_obj);
};

export const onTreat = function (lan, lans, index = 0) {
  let lan_obj = {};
  for (let key in lan) {
    let val = lan[key];
    if (typeof val == "string") {
      lan_obj[key] = lans[index];
      console.log(key, val, lan_obj[key]);
    } else if (val instanceof Array) {
      lan_obj[key] = [];
      lan_obj[key] = onTreat(val, lans, index).lan_obj;
      index = onTreat(val, lans, index).index;
    } else if (val instanceof Object) {
      lan_obj[key] = {};
      lan_obj[key] = onTreat(val, lans, index).lan_obj;
      index = onTreat(val, lans, index).index;
    }
    index += 1;
  }
  index -= 1;
  return {
    lan_obj,
    index,
  };
};

export const setTreat = function (cn) {
  let lang_str = "";
  treat(cn);

  function treat(lan) {
    let lan_obj = {},
      index = 0;
    for (let key in lan) {
      let val = lan[key];
      if (typeof val == "string") {
        lan_obj[index] = val;
        lang_str += `${val}\n`;
      } else if (val instanceof Array) {
        lan_obj[index] = [];
        lan_obj[index] = treat(val);
      } else if (val instanceof Object) {
        lan_obj[index] = {};
        lan_obj[index] = treat(val);
      }
      index += 1;
    }
    return lan_obj;
  }
  onRepeat(cn, lang_str.split("\n"));
  return lang_str;
};



export const setLocalStorage = (key, data, datetime = 0) => {
  let cacheValue = {
    content: data,
    datetime: parseInt(datetime) === 0 ? 0 : new Date().getTime() + parseInt(datetime) * 1000
  }
  return localStorage.setItem(key, JSON.stringify(cacheValue))
}
export const getLocalStorage = (key) => {
  try {
    const value = JSON.parse(localStorage.getItem(key))
    if (value) {
      let nowTime = new Date().getTime()
      console.log(nowTime,value.datetime,value.datetime - nowTime,nowTime>value.datetime ,'value.datetime')
      if (nowTime > value.datetime && value.datetime != 0) {
        localStorage.removeItem(key)
        return null;
      }
      return value.content
    }
    return null
  } catch (err) {
    return null
  }
}
export const removeLocalStorage = (key) => {
  return localStorage.removeItem(key)
}
export const clearLocalStorage = () => {
  return localStorage.clear()
}



function onRepeat(lan, lans, index = 0) {
  let lan_obj = {};
  for (let key in lan) {
    let val = lan[key];
    if (typeof val == "string") {
      if (val != lans[index]) {
        alert(`${key}出错`, index);
        return;
      }
    } else if (val instanceof Array) {
      lan_obj[key] = [];
      lan_obj[key] = onRepeat(val, lans, index).lan_obj;
      index = onRepeat(val, lans, index).index;
    } else if (val instanceof Object) {
      lan_obj[key] = {};
      lan_obj[key] = onRepeat(val, lans, index).lan_obj;
      index = onRepeat(val, lans, index).index;
    }
    index += 1;
  }
  index -= 1;
  return {
    lan_obj,
    index,
  };
}
